/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserRoleListResponse } from '../../models/user-role-list-response';

export interface CommonControllerFindRoles$Params {
}

export function commonControllerFindRoles(http: HttpClient, rootUrl: string, params?: CommonControllerFindRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerFindRoles.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserRoleListResponse;
      }>;
    })
  );
}

commonControllerFindRoles.PATH = '/common/roles';
